import React from 'react';
import PropTypes from 'prop-types';
import ProgressGrid from '../ProgressGrid';
import { getRowsToRender } from '../../../../utils/shared/zogUtils';

const ZonesOfGrowthTable = ({
    resultsByGrades,
    selectedPmPeriod,
    location,
    currentSchoolYear,
    saveStudentGoal,
    goalSetLookerEvent,
    isDemoModeOn,
    gradeToMeasureMapper,
    appSpecificParams,
}) => {
    const handleSaveStudentGoal = studentSaveInfo => {
        const allItems = { ...studentSaveInfo, schoolYear: currentSchoolYear };
        saveStudentGoal(allItems);
    };

    const { colSpans, rows } = getRowsToRender({
        resultsByGrades,
        selectedPmPeriod,
        location,
        handleSaveStudentGoal,
        goalSetLookerEvent,
        isDemoModeOn,
        gradeToMeasureMapper,
        appSpecificParams,
    });

    return (
        <ProgressGrid
            gridKey={selectedPmPeriod}
            colSpans={colSpans}
            rows={rows}
            sortableColumns={[0]}
        />
    );
};

ZonesOfGrowthTable.defaultProps = {
    selectedPmPeriod: null,
    resultsByGrades: [],
    location: {},
    currentSchoolYear: null,
    saveStudentGoal: () => {},
    goalSetLookerEvent: () => {},
    isDemoModeOn: false,
    gradeToMeasureMapper: [],
    appSpecificParams: {},
};

ZonesOfGrowthTable.propTypes = {
    selectedPmPeriod: PropTypes.string,
    resultsByGrades: PropTypes.array,
    location: PropTypes.object,
    currentSchoolYear: PropTypes.number,
    saveStudentGoal: PropTypes.func,
    goalSetLookerEvent: PropTypes.func,
    isDemoModeOn: PropTypes.bool,
    gradeToMeasureMapper: PropTypes.array,
    appSpecificParams: PropTypes.object,
};

export default ZonesOfGrowthTable;
